export function isNullish(x) {
  return x === null || x === undefined;
}
export function isNotNullish(x) {
  return !isNullish(x);
}